// TipTap utils (JS)

// Basic helpers
export function clamp(val, min, max) {
  if (val < min) return min
  if (val > max) return max
  return val
}

export const isNumber = (value) => typeof value === 'number'
export const isString = (value) => typeof value === 'string'
export const isBoolean = (value) => typeof value === 'boolean'
export const isFunction = (value) => typeof value === 'function'

export const getCssUnitWithDefault = (value, defaultUnit = 'px') => {
  if (value == null || value === '') return value
  const stringValue = isNumber(value) ? String(value) : String(value)
  const num = Number.parseFloat(stringValue)
  const unitMatch = stringValue.match(/[a-zA-Z%]+$/)
  const unit = unitMatch ? unitMatch[0] : defaultUnit
  return Number.isNaN(num) ? value : num + unit
}

/**
 * Check if an extension with a given name exists on the editor.
 * @param {import('@tiptap/core').Editor} editor
 * @param {string} name
 */
export function hasExtension(editor, name) {
  const { extensions = [] } = editor.extensionManager ?? {}
  return !!extensions.find((e) => e.name === name)
}

/**
 * Check if a mark or node (by name) is enabled and currently active.
 * @param {import('@tiptap/core').Editor} editor
 * @param {string} name
 */
export const isExtEnableAndActive = (editor, name) => {
  const { schema } = editor
  const markType = schema.marks?.[name]
  const nodeType = schema.nodes?.[name]
  if (markType) return editor.isActive(markType.name)
  if (nodeType) return editor.isActive(nodeType.name)
  return false
}

// Re-exports from lodash
export { default as differenceBy } from 'lodash/differenceBy'
export { default as isEqual } from 'lodash/isEqual'
export { default as omit } from 'lodash/omit'
export { default as throttle } from 'lodash/throttle'